var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
                  content: _vm.tipText,
                  show: _vm.showTip,
                  trigger: 'manual',
                  placement: 'top',
                }),expression:"{\n                  content: tipText,\n                  show: showTip,\n                  trigger: 'manual',\n                  placement: 'top',\n                }"}],staticClass:"far fa-clone",on:{"click":function($event){return _vm.doCopy()},"mouseover":function($event){_vm.showTip = true},"mouseleave":_vm.closeTip}})])}
var staticRenderFns = []

export { render, staticRenderFns }